//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { ViewBox, XHeader, XInput, Group, Cell } from 'vux'

export default {
  name: 'add-friend',
  data () {
    return {
      username: '',

      cells: [
        {
          img: '',
          title: '雷达加朋友',
          subtitle: '添加身边的朋友'
        },
        {
          img: '',
          title: '面对面建群',
          subtitle: '与身边的朋友进入同一个群聊'
        },
        {
          img: '',
          title: '扫一扫',
          subtitle: '扫描二维码名片'
        },
        {
          img: '',
          title: '手机联系人',
          subtitle: '添加手机通讯录中的朋友'
        },
        {
          img: '',
          title: '公众号',
          subtitle: '获取更多资讯和服务'
        }
      ]
    }
  },
  methods: {
    search () {
      // 跳转
      this.$router.replace({
        name: 'detail',
        query: {
          mode: 'push',
          username: this.username
        }
      })
    }
  },
  components: {
    ViewBox,
    XHeader,
    XInput,
    Group,
    Cell
  }
}
